import React from 'react'
import Page from 'layouts/Page'
import Masthead, { MastheadOverlap } from 'layouts/Masthead'
import Container from 'layouts/Container'
import Box, { BoxSection } from 'layouts/Box'
import { Node, md } from 'djedi-react'

export default () => (
  <Page title="Villkor för ansökan" plain>
    <Masthead overlap plain>
      <Container size="medium">
        <h1>
          <Node uri="application-terms/heading">Villkor för ansökan</Node>
        </h1>
      </Container>
    </Masthead>
    <MastheadOverlap>
      <Container size="medium">
        <Box>
          <BoxSection>
            <Node uri="application-terms/text.md">
              {md`
                Genom att registrera en ansökan om att bli ledare
                samtycker den sökande till att Bolaget behandlar
                personuppgifter om denne i den utsträckning som krävs
                för hantering av ansökan. Om sökanden inte antas som
                ledare åtar sig Bolaget sig att på begäran radera
                ingivna handlingar, såsom CV och referenser. Sökande är
                införstådd med att en registrerad ansökan inte medför
                någon rätt att bli antagen som ledare utan det är upp
                till Bolaget att i varje enskilt fall bedöma enskild
                sökandes lämplighet för uppdraget. Om sökande inte
                antas som ledare har Bolaget rätt att omgående, och
                utan föregående meddelande, stänga ner sökandens konto.
              `}
            </Node>
          </BoxSection>
        </Box>
      </Container>
    </MastheadOverlap>
  </Page>
)



// WEBPACK FOOTER //
// ../source/static/ApplicationTerms.js